import axios from "axios";

const state = {
  status: "success",
  profile: JSON.parse(sessionStorage.getItem("user_profile") || "{}"),
  users: [],
  userCreateErrorMessage: null,
  editUser: {}
};

const getters = {
  userCreateErrorMessage: state => state.userCreateErrorMessage
};

const actions = {
  userRequest: ({ commit }) => {
    commit("userRequest");

    return axios.get(`/users/me`)
      .then((resp) => {
        commit("userSuccess", resp.data.user);
        return resp;
      })
      .catch((err) => {
        commit("userError", err);
        return Promise.reject(err);
      });
  },
  getAllUsers: ({ commit }) => {
    return axios.get(`/users`)
      .then((resp) => {
        commit("getAllUsersSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve all users", { root: true });
        return Promise.reject(err);
      });
  },
  clearCurrentUser: ({ commit }) => {
    commit("clearCurrentUser");
  },
  getUser: ({ commit }, id) => {
    return axios.get(`/users/${id}`)
      .then((resp) => {
        commit("getUserSuccess", resp.data);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  createUser: ({ commit, dispatch }, payload) => {
    commit("createUserRequest");

    return axios.post(`/users`, {
      email: payload.email
    })
      .then((resp) => {
        dispatch("getAllUsers");
        dispatch("snackbar/successMessage", `Successfully created new user`, { root: true });
        return resp;
      })
      .catch((err) => {
        commit("createUserError", err.response);
        return Promise.reject(err);
      });
  },
  validateUserRegistrationToken: ({ commit, dispatch }, token) => {
    return axios.get(`/users/register/${token}`)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  completeUserRegistration: ({ commit, dispatch }, payload) => {
    return axios.post(`/users/register`, payload)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  deleteUser: ({ dispatch }, id) => {
    return axios.delete(`/users/${id}`)
      .then((resp) => {
        dispatch("getAllUsers");
        dispatch("snackbar/successMessage", `User successfully deleted`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  updateUser: ({ dispatch, state }) => {
    return axios.patch(`/users/${state.editUser.id}`, state.editUser)
      .then((resp) => {
        dispatch("snackbar/successMessage", `User successfully updated`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  }
};

const mutations = {
  clearCurrentUser: state => {
    state.profile = null;
  },
  userRequest: state => {
    state.status = "loading";
  },
  userSuccess: (state, userData) => {
    sessionStorage.setItem("user_profile", JSON.stringify(userData));
    state.status = "success";
    state.profile = userData;
  },
  userError: (state, err) => {
    state.status = "error";
  },
  getAllUsersSuccess: (state, data) => {
    state.users = data.users;
  },
  createUserRequest: state => {
    state.userCreateErrorMessage = null;
  },
  createUserError: (state, response) => {
    state.userCreateErrorMessage = response.data.errors.email[0];
  },
  getUserSuccess: (state, data) => {
    state.editUser = data.user;
  },
  updateEditUser: (state, change) => {
    state.editUser[change.property] = change.value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
